import type { IconProps } from "./icon-types";

/**
 * 별(star, 빈 상태). 북마크/즐겨찾기 미선택 표시 등에서 사용.
 *
 * VS Code의 `VscStarEmpty`(bookmark 느낌) 의도를 c6 아이콘 세트 톤·크기에 맞춰
 * `react-icons/lu`의 `LuStar`(Lucide `star`)로 인라인 재현. 채워진 상태는 StarFilledIcon.
 * c6 패키지는 외부 아이콘 라이브러리를 import하지 않으므로(RFC-design-system-split §아이콘). 24 그리드 / stroke 기반.
 */
export const StarIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" />
  </svg>
);
